import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import AttendeeListItem from 'components/attendee-list-item'

import styles from './attendee-list.css'

const AttendeeList = ({ attendees, showCustomerData }) => (
  <div styleName="attendee-list">
    <div styleName="header">
      <Relayout gutter={false}>
        <RelayoutItem sm="12" lg="4">
          <div styleName="attendee">Attendee</div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="3">Ticket type</RelayoutItem>
        <RelayoutItem sm="12" lg="2">Tickets</RelayoutItem>
        {showCustomerData && <RelayoutItem sm="12" lg="3">Contact</RelayoutItem>}
      </Relayout>
    </div>
    {attendees && attendees.map(
      (attendee, i) => <AttendeeListItem showCustomerData={showCustomerData} {...attendee} key={i} />
    )}
  </div>
)

AttendeeList.propTypes = {
  attendees: PropTypes.array,
  showCustomerData: PropTypes.bool,
}

export default CSSModules(AttendeeList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/attendee-list/attendee-list.js
 **/